import { render, staticRenderFns } from "./CostoProveedorReportComponent.vue?vue&type=template&id=60c62d91&"
import script from "./CostoProveedorReportComponent.vue?vue&type=script&lang=js&"
export * from "./CostoProveedorReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports